import { createContext, useContext, useEffect } from "react"

type Theme = "dark" | "light"

type ThemeProviderProps = {
  children: React.ReactNode
  storageKey?: string
}

type ThemeProviderState = {
  theme: Theme
}

const initialState: ThemeProviderState = {
  theme: "light",
}

const ThemeProviderContext = createContext<ThemeProviderState>(initialState)

export function ThemeProvider({
  children,
  // storageKey = "vite-ui-theme",
  ...props
}: ThemeProviderProps) {
  const theme: Theme = "light"

  useEffect(() => {
    const root = window.document.documentElement

    root.classList.remove("light", "dark")
    if (theme !== "light") {
      root.classList.add(theme)
    }
    root.classList.add("font-pelikan")
  }, [theme])

  const value = {
    theme,
    // setTheme: (theme: Theme) => {
    //   localStorage.setItem(storageKey, theme)
    //   setTheme(theme)
    // },
  }

  return (
    <ThemeProviderContext.Provider {...props} value={value}>
      {children}
    </ThemeProviderContext.Provider>
  )
}

export const useTheme = () => {
  const context = useContext(ThemeProviderContext)

  if (context === undefined)
    throw new Error("useTheme must be used within a ThemeProvider")

  return context
}
